module.exports = __webpack_public_path__ + "img/motivauswahl_2.b99e450d.jpg";